// Accordion default
// Created: 06/2016
// Updated: 08 aout 2016 // ajout only breakpoint et responsive
// Created for: Gift Cards page

(function ($) {

    'use strict';
    $.fn.accordion_default = function () {
        return this.each(function () {
            var accordion = $(this),
                accordion_btn = accordion.find('[data-action="toggle-accordion"]'),
                only_breakpoint = (accordion.data('only-breakpoint') !== undefined) ? accordion.data('only-breakpoint') : null,
                is_initialized = false,
                close_other = accordion.data('close-all-from'),
                is_preview = accordion.data('accordion-preview');

            accordion.addClass('accordion-default-is_initialized');

            function expand() {
                var expanded = accordion.hasClass('active');
                accordion_btn.attr('aria-expanded', (expanded === true) ? true : false);

                if ($(this).attr('aria-expanded') === 'false') {
                    $(this).siblings('.accordion--text').attr('aria-hidden', 'true');
                } else {
                    $(this).siblings('.accordion--text').attr('aria-hidden', 'false');
                }
            }

            function tab() {
                if (!accordion.hasClass('active')) {
                    accordion.find('.accordion--text, [data-accordion="content"]').hide();
                }

                accordion_btn.on(Revealizr.clickORtouchend, function () {

                    //target the accordion that was just clicked
                    accordion.addClass('accordion--in-use');

                    if (!Revealizr.swiping) {
                        if (close_other != undefined) {
                            //Close every accordion except the one that was just clicked
                            $(close_other).find('[data-feature="accordion-default"]:not(.accordion--in-use)').removeClass('active').find('.accordion--text, [data-accordion="content"]').slideUp('fast');
                            $(close_other).find('[data-action="toggle-accordion"]').attr('aria-expanded', "false");
                        }

                        if (is_preview == true) {
                            accordion.toggleClass('active');
                            addPreviewHeight(calculatePreviewTextHeight());
                            accordion.find('.toggle-preview--btn').toggleClass('btn--active');
                        } else {
                            accordion.toggleClass('active').find('.accordion--text, [data-accordion="content"]').slideToggle('fast');
                        }
                        expand();
                    }
                    accordion.removeClass('accordion--in-use');
                });
                is_initialized = true;
            }

            function destroy() {
                accordion.removeClass('active').find('.accordion--text,.accordion--text--preview, [data-accordion="content"]').attr('style', '');
                accordion_btn.off(Revealizr.clickORtouchend).attr('aria-expanded', "false");
                is_initialized = false;
            }

            function init_destroy() {
                if (only_breakpoint === Revealizr.currentViewportSize && !is_initialized) {
                    tab();
                    expand();
                } else if (only_breakpoint !== Revealizr.currentViewportSize && is_initialized) {
                    destroy();
                }
            }

            function calculatePreviewTextHeight() {
                var totalHeight = 0;
                accordion.find('.accordion--text--preview').children().each(function () {
                    totalHeight += $(this).outerHeight(true);
                });
                return totalHeight;
            }

            function init_previewMode() {
                accordion.find('.accordion--text--preview').attr('style', '');
                var totalChildrenHeight = calculatePreviewTextHeight();
                if (totalChildrenHeight <= 120) {
                    accordion.addClass('accordion--preview--disabled');
                }
            }

            function addPreviewHeight(openedHeight) {
                if (accordion.hasClass('active')) {
                    accordion.find('.accordion--text--preview').attr('style', 'height:' + openedHeight + 'px');
                } else if (!accordion.hasClass('active')) {
                    accordion.find('.accordion--text--preview').attr('style', '');
                }
            }

            if (only_breakpoint === null) {
                tab();
            } else if (only_breakpoint !== null) {
                init_destroy();
                $(window).on(Revealizr.resizeORorientation, _.throttle(init_destroy, 100));
            }

            if (is_preview == true) {
                init_previewMode();
            }
        });
    }
})(jQuery);

$(document).ready(function () {
    $('[data-feature="accordion-default"]').accordion_default();
});
